/**
 * RESPONSIBILITY: the contact-requests page — an admin's list of what visitors sent.
 *
 * FOR ADMINS AND THE WELCOME TEAM, in two places that must agree. Here, so nobody else is
 * shown a list they cannot have; and in the endpoints, which is the one that actually
 * matters - a page that hides itself is only a courtesy. The rule is requests/access.ts,
 * and the data is not even asked for unless it lets the person in.
 */
import { useAuth } from '@framework/react';
import { SectionName, canSeeRequests } from '@app/sections';
import { SectionUpdate } from '../cms';
import { RequestsView, useRequests, ARCHIVE } from '../site';

export function RequestsPage({ path }: { path: readonly string[] }) {
  const { session } = useAuth();
  const allowed = canSeeRequests(session?.roles);
  const { rows, failed, setDone, saveNote } = useRequests(allowed);

  return (
    <main>
      <SectionUpdate name={SectionName.Requests}>
        {(c) => allowed
          ? <RequestsView c={c} rows={rows} failed={failed} archive={path[0] === ARCHIVE} onDone={setDone} onNote={saveNote} />
          : <section className="band"><div className="wrap"><p>{c.signInMessage}</p></div></section>}
      </SectionUpdate>
    </main>
  );
}
